/* esm.sh - @radix-ui/react-menu@2.1.16 */
export * from "/*@radix-ui/react-menu@2.1.16/esnext/react-menu.mjs";
